<template>
  <div class="FooterVue">
    <footer id="footer">
      <div class="logo-container" href="/">
        <h3>Heimr dis Interesse gweckt?</h3>
        <a href="mailto:info@ocular.ch">
          <button class="btn-big btn-border-white">info@ocular.ch</button>
        </a>
      </div>
      <div class="footbottom">
        <router-link to="/impressum">Impressum</router-link>
        <p>&copy; 2023 Ocular KLG</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "FooterVue",
};
</script>

<style lang="scss" scoped>
footer {
  text-align: center;
  display: flex;
  flex-direction: column;
  color: #ebebeb;
  background-color: #141d23;
  a,
  p {
    color: #808080;
    font-size: 1.3rem;
    font-weight: 100;
    text-decoration: none;
    letter-spacing: 0.05rem;
    padding: 0.2rem;
    display: inline-block;
  }
  a:hover {
    color: #ebebeb;
  }
  .logo-container {
    align-items: center;
    padding-top: 11rem;
    padding-bottom: 5rem;
    h3 {
      color: #ebebeb;
      padding-bottom: 3rem;
    }
    .socialmedia-icos {
      display: flex;
      justify-content: flex-end;
      padding-right: 3vw;
      width: 100%;
      .icon-wrapper {
        display: flex;
        width: 15vw;
        justify-content: space-evenly;
        svg {
          circle {
            fill: #1f2d35;
            transition: 0.3s;
          }
          path {
            fill: #f5f4f3;
            transition: 0.3s;
          }
          &:hover {
            circle {
              fill: #f5f4f3;
            }
            path {
              fill: #1f2d35;
            }
          }
        }
      }
    }
  }
  .footlist {
    display: flex;
    justify-content: space-evenly;
    text-align: left;
    padding: 5rem 35vw 3rem 35vw;
    margin-top: 0rem;
    ul {
      list-style: none;
      line-height: 1.5;
      li {
        strong {
          color: #f5f4f3;
          font-size: 2rem;
          text-transform: capitalize;
          font-weight: 600;
        }
        a {
          font-weight: 300;
          font-size: 1.5rem;
          padding: 0;
          line-height: 2.5rem;
        }
      }
    }
  }
  .footbottom {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem 0 2rem 0;
    p,
    a {
      padding: 0 4rem 0 4rem;
      font-weight: 200;
    }
  }
}
@media only screen and (max-width: 1024px) {
  footer {
    .logo-container {
      .socialmedia-icos {
        justify-content: center;
        padding: 0;
        margin-top: 5vh;
        .icon-wrapper {
          width: 80vw;
        }
      }
    }
    .footlist {
      display: grid;
      grid-template-columns: 27vw 27vw;
      grid-gap: 5vw;
      ul {
        display: flex;
        flex-direction: column;
        li {
          display: flex;
        }
      }
    }
  }
}
</style>